<template>
    <div>
        <CRow class="mb-3 search-panel">
            <CCol sm="2" xs="12">
                <BaseInput :options="descriptionInput.options" :data="descriptionInput.data"
                    :listener="descriptionInput.listener" />
            </CCol>
            <CCol>
                <div class="form-group">
                    <label style="color: white"></label>
                    <div style="margin-top: 10px">
                        <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
                            class="btn-action-primary" @click="loadDataMainTable(true)">
                            <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
                        </CButton>
                    </div>
                </div>
            </CCol>
        </CRow>
        <CCard class="content-fade-in mt-3p5">
            <CCardBody>
                <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
                    ref="mainTable">

                    <template #serialId="{ item }">
                        <td>
                            <span v-if="item.serialId != null && item.serialId != ''">
                                {{ item.serialId }}
                                <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"
                                    @click="copyPhoneNumber(item.serialId)"></i>&nbsp;
                            </span>
                        </td>
                    </template>
                    <template #mac="{ item }">
                        <td>
                            <span v-if="item.mac != null && item.mac != ''">
                                {{ item.mac }}
                                <i v-c-tooltip="'Sao chép'" class="fa fa-copy" style="font-size: 17px;font-weight: 600;"
                                    @click="copyPhoneNumber(item.mac)"></i>&nbsp;
                            </span>
                        </td>
                    </template>
                </BaseTable>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseExportModal from "../base/BaseExportModal";

export default {
    name: "ProductLotSerialList",
    components: {
        BaseSwitch,
        BaseTable,
        ModalConfirm,
        BaseInput,
        BaseSelect,
        BaseExportModal
    },
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success"
        },
        showErrorMsg: {
            type: "error",
            title: "Error"
        },
        showWarningMsg: {
            type: "warn",
            title: "warn"
        }
    },
    data() {
        let that = this;

        return {
            labelIcon: {
                labelOn: '\u2713',
                labelOff: '\u2715'
            },
            descriptionInput: {
                options: {
                    placeholder: "Từ khóa",
                    label: 'Từ khóa'
                },
                data: {
                    name: "search",
                    model: "",
                    updateTrigger: function () {
                        return that.$refs.mainTable;
                    }
                }
            },
            mainTable: {
                options: {
                    fields: [
                        { key: "productName", label: "Sản phẩm" },
                        { key: "serialId", label: "Serial Id" },
                        { key: "mac", label: "Mac" },
                        { key: "qrCodeData", label: "QR Code Data" },
                    ],
                    slots: ['serialId', 'mac'],
                    sorter: true,
                    columnFilter: false,
                    clickableRows: true,
                    hover: false,
                    itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
                    pageSize: 20,
                },
                dataSource: {
                    url: "/product-lot-serial/getPages",
                    dataSubmit: function () {
                        return that.$helper.setupDataSubmit(that.$data);
                    },
                    response: function (dataResponse) {
                        return dataResponse.data;
                    }
                }
            }
        };
    },
    methods: {
        loadDataMainTable: function (isUpdateFilter) {
            this.$refs.mainTable.loadData(true, isUpdateFilter);
        },
        copyPhoneNumber(phoneNumber) {
            navigator.clipboard.writeText(phoneNumber);
        },
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
    },
    computed: {}
};
</script>
<style scoped>
.td-roles {
    max-width: 250px;
}
</style>